import { useGlobSetting } from '@/hooks/setting'
import microApp from '@micro-zoe/micro-app'

microApp.start({
  iframe: true, // 全局开启iframe沙箱，默认为false
  inline: true, // 全局开启内联script模式运行js，默认为false
  'keep-alive': true,
  destory: true,
  plugins: {
    modules: {
      'my-app': [
        {
          loader(code) {
            return code
          }
        }
      ],
      'page': [
        {
          loader(code) {
            return code
          }
        }
      ],
      'monitorPage': [
        {
          loader(code) {
            return code
          }
        }
      ],
      'historyPage': [
        {
          loader(code) {
            return code
          }
        }
      ]
    }
  },
  // 忽略资源加载过滤
  excludeAssetFilter: (url) => {
    return true
  }
})

// microApp.preFetch(
//   [
//     {
//       name: 'my-app',
//       url: useGlobSetting().koneOnlineUrl + '/kol/index.html',
//       iframe: true, // 全局开启iframe沙箱，默认为false
//       inline: true, // 全局开启内联script模式运行js，默认为false
//       level: 2 // 预加载等级，可选（分为三个等级：1、2、3，1表示只加载资源，2表示加载并解析，3表示加载解析并渲染，默认为2）
//     }
//   ],
//   100
// )

export const getMicroAppInstance = () => {
  return microApp
}
